import { render, staticRenderFns } from "./DeliveryUnallocatedHierarchy.vue?vue&type=template&id=45a3201b&scoped=true"
import script from "./DeliveryUnallocatedHierarchy.vue?vue&type=script&lang=js"
export * from "./DeliveryUnallocatedHierarchy.vue?vue&type=script&lang=js"
import style0 from "./DeliveryUnallocatedHierarchy.vue?vue&type=style&index=0&id=45a3201b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3201b",
  null
  
)

export default component.exports